import React, { useState, useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import SideMenu from './components/menu/side-menu';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Button from 'react-bootstrap/Button';

import Home from './components/home';
import Login from './components/login';
import 'react-toastify/dist/ReactToastify.css'
import { Auth } from 'recupero-comunes';

// Actions
import { cerrarSesionAction } from './store/actions/login-action';

import './styles/menu.css';
import { CargaMasivaComponent, CargaMasivaActualizaRecuperoComponent } from 'recupero-ingreso-casos';
import { AreaGestionCompaniaComponent } from 'recupero-area-trabajo';
import { AsignarResponsableComponent, RecordLiquidationComponent} from 'recupero-gestion-casos';
import { BitacoraComponent } from 'recupero-bitacora';
import { RecuperoDirectoComponent, RecuperoEntreCIASComponent } from 'recupero-area-trabajo-encargado-recupero';
import { PrepararCartaCobroComponent, ProcesarRespuestaRecobroComponent, LegalizacionPagoRecobroComponent, VerificaIngresoPagoComponent, RecepcionCobroCiaTerceroComponent, AprobacionPagoCiaTerceroComponent, LegalizarPagoCiaTerceroComponent, EmisionPagosCiasComponent, ConsultaEmisionPagosComponent} from 'recupero-gestion-recuperador';
import { RecepcionaCasoAsignadoComponent, ProcesoExtrajudicialComponent, AreaIngresoRecuperosCuotaComponent, PagoCuotasComponent, CargaRecuperoJudicializaComponent  } from 'recupero-gestion-directa';
import { ReasignarCerrarComponent, AtenderSolicitudDescuentoComponent, AreaBusquedaCasosComponent, DetalleCasoComponent, ConfirmarIngresoRecobroComponent,
    GestionRecuperoComponent, GestionDefensaCIAComponent, CargaEmisionPagosCIAComponent, CargaArchivoActualizacionCIAComponent, DescargaMovimientosComponent, 
    Consulta360Component, CargaDenuncioComponent, CargaRecuperoComponent, CasosRecuperoJudicializaComponent, CargaCasosCerradosSinrecComponent } from 'recupero-gestion-compania';
import { RecepcionaCasoComponent, GestionDefensaComponent } from 'defensa-gestion-externos';
import { InformeAdministracionComponent, DescargaCasosComponent } from 'recupero-dashboard-reports';

const AppRoutes = () => {

    const dispatch = useDispatch();
    const [authenticated, setAuthenticated] = useState(null);
    const [inactive, setInactive] = useState(false);
    const [inactiveSide, setInactiveSide] = useState(false);
    

    const handleInactiveSide = () => {
        setInactiveSide(!inactiveSide);
    }

    const handleSuccess = () => {
        setAuthenticated(true);
    }

    const handleLogout = () => {

        dispatch(cerrarSesionAction()).then((result) => {

            setAuthenticated(false);

        }).catch((error) => {

            console.error(error);
        });
    }
 
    useEffect(() => {
        setAuthenticated(Auth.loggedIn());
    }, []);

    if (authenticated != null) {
        return (
            <BrowserRouter>
                {
                authenticated &&
                <SideMenu onCollapse={(inactive) => { setInactive(inactive); }} inactiveSide={inactiveSide} onLogout={() => handleLogout()} />
                }
                <div className={authenticated ? `container-menu ${inactive ? "inactive" : ""}` : "div-signin"}>
                    {
                        authenticated &&
                        <Navbar expand="lg" variant="light" bg="light" className='mb-4'>
                            <Container fluid>
                                <Navbar.Brand>
                                    <Button variant="secondary me-4" type="button" onClick={() => { handleInactiveSide() }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                                        </svg>
                                    </Button>
                                    <span className='align-middle me-2'><span role="img" aria-label="waving hand">👋</span> Hola</span>
                                    <span className='align-middle'>{Auth.currentUser()?.nombreUsuario}</span>
                                </Navbar.Brand>
                                <Button variant="secondary" type="button" onClick={() => { handleLogout() }}>Cerrar Sesión</Button>
                            </Container>
                        </Navbar>
                    }
                    <Routes>
                        {
                            authenticated ?
                                <>
                                <Route path="/" element={<Home />} />

                                {/* MODULO recupero-ingreso-casos */}
                                <Route path="/carga-masiva" element={<CargaMasivaComponent />} />
                                <Route path="/carga-masiva-actualiza-recupero" element={<CargaMasivaActualizaRecuperoComponent />} />

                                {/* MODULO recupero-gestion-compania' */}
                                <Route path='/iniciar-gestion-recupero-cia' element={<GestionRecuperoComponent/>}/>{/*INICIA GESTION DE RECUPERO*/}
                                <Route path='/iniciar-gestion-defensa-cia' element={<GestionRecuperoComponent/>}/>{/*INICIA GESTION DE DEFENSA*/}
                                
                                {/* MODULO recupero-gestion-casos */}
                                <Route path='/asignar-responsable' element={<AsignarResponsableComponent />}/>
                                <Route path='/antecedentes-liquidacion' element={<RecordLiquidationComponent />}/> */
                                
                                {/* MODULO recupero-bitacora */}
                                <Route path='/bitacora' element={<BitacoraComponent />}/>

                                {/* MODULO recupero-gestion-recuperador */}
                                <Route path='/preparar-carta-cobro' element={<PrepararCartaCobroComponent />}/>
                                <Route path='/respuesta-recobro' element={<ProcesarRespuestaRecobroComponent/>}/>
                                <Route path='/legalizar-recobro' element={<LegalizacionPagoRecobroComponent/>}/> 
                                <Route path='/conciliar-pagos-recupero' element={<VerificaIngresoPagoComponent/>}/> 
                                <Route path='/emision-pagos-cias' element={<EmisionPagosCiasComponent/>}/>
                                <Route path='/consulta-emision-pagos' element={<ConsultaEmisionPagosComponent/>}/>

                                <Route path='/recepcionar-cobro-cia-tercero' element={<RecepcionCobroCiaTerceroComponent/>}/> 
                                <Route path='/aprobacion-pago-cia-tercero' element={<AprobacionPagoCiaTerceroComponent/>}/> 
                                <Route path='/legaliza-emision-pago-tercero' element={<LegalizarPagoCiaTerceroComponent/>}/> 
                                
                                {/* MODULO recupero-gestion-directa */}
                                <Route path='/recepciona-caso-asignado' element={<RecepcionaCasoAsignadoComponent/>}/> 
                                <Route path='/recupero-extra-judicial' element={<ProcesoExtrajudicialComponent/>}/> 
                                <Route path='/recupero-judicial' element={<ProcesoExtrajudicialComponent/>}/> 
                                <Route path='/carga-recupero-judicializa' element={<CargaRecuperoJudicializaComponent/>}/> 
                                
                                {/* MODULO recupero-gestion-compania */}
                                <Route path='/reasigna-cierra-anula' element={<ReasignarCerrarComponent/>}/> 
                                <Route path='/atiende-solicitud-descuento' element={<AtenderSolicitudDescuentoComponent/>}/> 
                                <Route path='/area-busqueda-casos' element={<AreaBusquedaCasosComponent/>}/> {/*AREA DE BUSQUEDA CONSULTA DE CASOS*/}
                                <Route path='/detalle-caso' element={<DetalleCasoComponent/>}/>{/*DETALLE DE CASO - CONSULTA DE CASOS*/}
                                <Route path='/confirmar-ingreso-recupero' element={<ConfirmarIngresoRecobroComponent/>}/>
                                
                                {/* MODULO recupero-area-trabajo-encargado-recupero */}
                                <Route path='/area-trabajo-recupero-directo' element={<RecuperoDirectoComponent/>}/>{/*AREA DE TRABAJO ABOGADO (recupero y defensa)*/}
                                <Route path='/area-trabajo-recupero-companias' element={<RecuperoEntreCIASComponent/>}/>{/*AREA DE TRABAJO ENTRES CIAS */}
                                
                                {/* MODULO recupero-area-trabajo */}
                                <Route path='/area-gestion-compania' element={<AreaGestionCompaniaComponent/>}/>{/*AREA DE TRABAJO CIA (recupero y defensa)*/}                                

                                {/* MODULO defensa-gestion-externos */}
                                <Route path='/recepcion-caso-defensa' element={<RecepcionaCasoComponent/>}/> 
                                <Route path='/gestion-caso-defensa' element={<GestionDefensaComponent/>}/> 
                                
                                {/* MODULO recupero-gestion-compania */}
                                <Route path='/gestion-caso-defensa-cia' element={<GestionDefensaCIAComponent/>}/> 
                                <Route path='/carga-pagos-emitidos-cia' element={<CargaEmisionPagosCIAComponent/>}/> 
                                <Route path='/descarga-mov-actualizacion-cia' element={<DescargaMovimientosComponent/>}/> 
                                <Route path='/carga-mov-actualizacion-cia' element={<CargaArchivoActualizacionCIAComponent/>}/> 
                                <Route path='/consulta-gestion-360' element={<Consulta360Component/>}/> 
                                <Route path='/casos-recupero-judicializa' element={<CasosRecuperoJudicializaComponent/>}/> 
                                <Route path='/carga-casos-cerrados-sinrec' element={<CargaCasosCerradosSinrecComponent/>}/> 

                                {/* MODULO recupero-dashboard-reports*/}
                                <Route path='/informes-administracion' element={<InformeAdministracionComponent/>}/>
                                <Route path='/descarga-casos' element={<DescargaCasosComponent/>} />  

                                 {/* MODULO recupero-gestion-compania */}
                                 {/*<Route path='/carga-analytic' element={<CargaAnalyticComponent/>}/> 
                                 <Route path='/descarga-analytic' element={<DescargaMovimientosAnalytic/>}/> */}

                                 <Route path='/carga-denuncios' element={<CargaDenuncioComponent/>}/>
                                 
                                 <Route path='/area-ingreso-recuperos-cuota' element={<AreaIngresoRecuperosCuotaComponent/>}/> 
                                 <Route path='/ingreso-pago-cuotas' element={<PagoCuotasComponent/>}/> 

                                 <Route path='/carga-recuperos' element={<CargaRecuperoComponent/>}/>


                                <Route path="*" element={<Navigate to="/" />} />
                            </> :
                            <>
                                <Route path="/login" element={<Login onSuccess={() => { handleSuccess() }} />} />
                                <Route path="*" element={<Navigate to="/login" />} />
                            </>
                        }
                    </Routes>
                </div>
            </BrowserRouter>
        )
    } else {
        return <></>
    }

}


export default AppRoutes;